<template>
  <div class="dropdown">
    <div class="bell-wrapper" @click="openNotificationMenu">
      <font-awesome-icon icon="bell" size="2x" class="dropdown-btn" />
      <span v-if="hasAnyUnreadNotifications" class="badge-number"></span>
    </div>
    <div
      class="dropdown-content"
      :class="{ open: open }"
      @mouseover="openMenu"
      @mouseleave="closeMenu"
    >
      <div v-if="hasNotifications">
        <div v-for="notification in getNotifications" :key="notification.id">
          <notification-menu-item
            :notification="notification"
            @click.native="goToNotification(notification)"
          />
        </div>
        <infinite-loading @infinite="loadNotificationPage" spinner="spiral">
          <div slot="no-results"></div>
          <div slot="no-more"></div>
        </infinite-loading>
      </div>
      <div v-else class="no-notifications">
        <h6>You have no notifications</h6>
        <p>Follow some active shops to get notifications</p>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationMenuItem from "@/components/NotificationMenuItem.vue";
import { mapGetters } from "vuex";

export default {
  name: "NotificationMenu",
  components: {
    NotificationMenuItem,
  },
  data() {
    return {
      open: false,
      page: 0,
    };
  },
  computed: {
    ...mapGetters({
      getNotifications: "notification/getNotifications",
      hasAnyUnreadNotifications: "notification/hasAnyUnreadNotifications",
    }),
    hasNotifications() {
      return this.getNotifications.length > 0;
    },
  },
  methods: {
    openMenu() {
      this.open = true;
    },
    openNotificationMenu() {
      this.trackEvent("Notifications", "Open");
      this.open = true;
    },
    closeMenu() {
      this.open = false;
    },
    goToNotification(notification) {
      this.closeMenu();
      this.trackEvent("Notifications", "Click", notification.shopId);

      this.$store
        .dispatch("notification/markNotificationAsRead", notification.id)
        .then(() => {
          this.$router.push(`/shop/${notification.shopId}`);
          this.$store.dispatch("notification/checkForUnreadNotifications");
        })
        .catch(() => {
          this.$router.push(`/shop/${notification.shopId}`);
        });
    },
    loadNotificationPage($state) {
      this.$store.dispatch("notification/fetchNotifications", this.page).then(
        (notifications) => {
          this.page += 1;
          if ($state) {
            if (notifications.length) {
              $state.loaded();
            } else {
              $state.complete();
            }
          }
        },
        (error) => {
          console.log("Error fetching notifications: ", error);
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.badge-number {
  position: absolute;
  top: -2px;
  right: -3px;
  color: white;
  background-color: red;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  line-height: 18px;
  font-size: 10px;
  text-align: center;
  cursor: pointer;
  z-index: 2;
}

.dropdown {
  pointer-events: all;
  .bell-wrapper {
    padding: 0 7px;
    border-radius: 50%;
    background-color: #303030;
    position: relative;
  }
  .dropdown-btn {
    align-items: center;
    // color: rgba(0, 0, 0, 0.6);
    color: #eee;
    width: 18px;
    margin-top: 1px;
    &:hover {
      color: white;
    }
  }

  .dropdown-content {
    display: none;
    position: absolute;
    cursor: pointer;
    right: 0;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    outline: none;
    box-sizing: border-box;
    width: 300px;
    height: fit-content;
    overflow-y: auto;
    max-width: 480px;
    max-height: 325px;
    &.open {
      display: block;
    }
  }
}

.no-notifications {
  color: #262626;
  padding-top: 10%;
  text-align: center;
  h6 {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.04em;
    line-height: 28px;
    text-transform: none;
    overflow-wrap: break-word;
  }
  p {
    padding-top: 0;
    font-size: 12px;
    line-height: 24px;
  }
}
</style>
